import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterEvent } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ModalService } from '../../../core/modal/modal.service';
import { ModalModule } from '../../../core/modal/modal.module';

@Component({
  selector: 'tax-cto-modules-modal',
  templateUrl: './cto-modules.component.html',
  styleUrls: ['./cto-modules.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    ModalModule,
    FormsModule,
    TranslateModule,
  ],
})
export class CtoModulesModalComponent implements OnInit {
  // @ts-ignore
  @Input() initialState;

  modules: { 'cto.permission.generate_token'?: boolean; 'cto.permission.view_balance'?: boolean } = {
    'cto.permission.generate_token': false, 'cto.permission.view_balance': false,
  };

  selectAll: boolean = false;

  constructor(
    private modalService: ModalService,
  ) {}

  ngOnInit(): void {
    // @ts-ignore
    this.initialState.map(item => this.modules[item] = true);
  }

  checkboxChange() {
    this.selectAll = false;
  }

  updateAll(event: Event | RouterEvent): void {
    if (event instanceof RouterEvent) return;

    const { checked } = event.currentTarget as HTMLInputElement;
    // @ts-ignore
    Object.keys(this.modules).forEach(key => this.modules[key] = checked);
  }

  saveSelectedModules(): void {
    const selectedModules: Array<string> = [];
    for (const [key, value] of Object.entries(this.modules)) {
      if (value) {
        selectedModules.push(key);
      }
    }
    this.modalService.close(selectedModules);
  }

  closeModal() {
    this.modalService.close();
  }
}
